import { Yii } from "libraries/interfaces/Yii";
import { ILabels } from "libraries/interfaces/ILabels";

export const WORDING: ILabels = {
    loadingMessage: Yii.t('wui-sasha-js', 'Chargement du traitement en cours'),
    bookingList: Yii.t('wui-sasha-js', 'Liste des dossiers'),
    status: Yii.t('wui-sasha-js', 'Statuts'),
    model: Yii.t('wui-sasha-js', 'Basé sur le modèle'),
    whenCreated: Yii.t('wui-sasha-js', 'Date de la demande'),
    whenBegan: Yii.t('wui-sasha-js', 'Début du traitement'),
    whenEnded: Yii.t('wui-sasha-js', 'Fin du traitement'),
    sending: Yii.t('wui-sasha-js', 'Envoi en cours'),
    retry: Yii.t('wui-sasha-js', 'Relancer'),
    recallTask: Yii.t('wui-sasha-js', 'Traitement en cours'),
    resendAllTask: Yii.t('wui-sasha-js', 'Relancer les tâches en erreur ou avec avertissement'),
    refresh: Yii.t('wui-sasha-js', 'Rafraîchir')
};